const topMovie = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const secMovie = document.querySelector('#jsSecMovie');
    const listAreaOuter = secMovie.querySelector('.js-list-area-outer');
    const moreArea = secMovie.querySelector('.js-more-area');
    const moreBox = moreArea.querySelector('.js-more-box');
    const moreBoxP = moreArea.querySelector('.js-more-box p');

    if (sW > 750) {

    } else {
      let listAreaH = listAreaOuter.clientHeight;
      console.log(listAreaH)
      listAreaOuter.style.height = `${92}rem`

      moreBox.addEventListener('click', () => {
        if (moreBox.classList.contains('open') == true) {
          moreBox.classList.remove('open');
          moreBoxP.innerText = '& MORE';
          listAreaOuter.style.height = `${92}rem`
        } else {
          moreBox.classList.add('open');
          moreBoxP.innerText = '& CLOSE';
          listAreaOuter.style.height = `${269}rem`
        }
      });
    }




  }
})()
export default topMovie;